<template>
  <b-row
    align-v="stretch"
    class="week-nothing"
  >
    <b-col
      v-if="question.type == 'exitmodal'"
      align-self="center"
    >
      <div
        class="tw-flex tw-flex-col tw-mx-auto"
        style="max-width: 768px"
      >
        <h2 class="question-title-v2 tw-mb-4 tw-text-white">
          {{ question.title }}
        </h2>
        <p class="sub-text group-mb tw-mb-6 tw-text-white">
          {{ question.question }}
        </p>

        <b-row
          align-v="center"
          class="tw-mt-12 tw-mb-12"
        >
          <b-col cols="auto">
            <b-avatar
              variant="primary"
              :src="question.doctor.profileUrl"
              size="7rem"
              square
            />
          </b-col>
          <b-col cols="auto">
            <h2 class="tw-mb-0 bold d-letter-spacing tw-text-white">
              Dr. {{ question.doctor.firstname }}
              {{ question.doctor.lastname }}
            </h2>
          </b-col>
        </b-row>

        <div>
          <b-button
            class="tw-px-6"
            pill
            variant="info"
            size="lg"
            @click="submitAnswer"
          >
            Complete
          </b-button>
        </div>
      </div>
    </b-col>
    <b-col
      v-else
      align-self="center"
      class="tw-flex tw-flex-col"
    >
      <h2 class="tw-text-center question-title-v2 tw-mb-2">
        {{ question.title }},
      </h2>
      <p
        v-if="question.description"
        class="sub-text group-mb tw-text-center tw-mb-6"
      >
        {{ question.description }}
      </p>
      <div class="tw-self-center">
        <b-button
          class="tw-px-6"
          pill
          variant="info"
          size="lg"
          :disabled="disabled"
          @click="submitAnswer"
        >
          Continue
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      disabled: false,
    };
  },
  methods: {
    submitAnswer() {
      this.disabled = true;
      this.$emit('submitAnswer', { id: this.question.id, answer: '' });
      this.disabled = false;
    },
  },
};
</script>

<style></style>
